import DEFAULT_BADGE_CLASS_NAME from '../../constants/badge';

const defaultBadge = ({ theme }) => ({
  '& .MuiBadge-badge': {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  },
});

const MuiBadge = {
  styleOverrides: {
    root: ({ theme }) => ({
      [`&.${DEFAULT_BADGE_CLASS_NAME}`]: defaultBadge({ theme }),
    }),
  },
};

export default MuiBadge;
